<template>
  <el-dialog title="编辑订单" class="global-dialog" :visible.sync="showDlg" width="700px" :before-close="handleClose">
    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form3" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="contractNo" label="合同编号">
              <el-input v-model="formData.contractNo" placeholder="请输入合同编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="specId" label="商品名称">
              <el-select filterable clearable v-model="formData.specId" @change="changeSpec" placeholder="请选择商品名称">
                <el-option v-for="(item, index) of guigeList" :value="item.specId" :label="item.specName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="lockedPrice" label="锁定单价(元)">
              <el-input-number v-model="formData.lockedPrice" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
<!--          <el-col :span="24">-->
<!--            <el-form-item prop="orderQuantity" label="锁定数量">-->
<!--              <el-input-number v-model="formData.orderQuantity" :min="0"></el-input-number>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <!-- <el-col :span="24">
            <el-form-item prop="pickupDate" label="提货日期">
              <el-date-picker v-model="formData.pickupDate" type="date" placeholder="提货日期" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
<!--            <el-form-item label="图片" prop="fileList">-->
<!--              <div class="uplaod-wrap">-->
<!--                <div v-if="formData.fileList && formData.fileList.length > 0" class="images-wrap">-->
<!--                  <div class="images-box" v-for="(item, index) of formData.fileList" :key="index">-->
<!--                    <i class="el-icon-error close-icon" @click="delImage(index)"></i>-->
<!--                    <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"-->
<!--                      :preview-src-list="imageArr" fit="cover" />-->
<!--                  </div>-->
<!--                </div>-->
<!--                <el-upload class="upload-demo" :on-preview="onPreview" :action="$apis.common.uploadUrl" multiple-->
<!--                  :on-success="handleSuccess" :before-upload="beforeUpload" :show-file-list="false"-->
<!--                  list-type="picture-card">-->
<!--                  <i class="el-icon-plus"></i>-->

<!--                  <div slot="tip" class="el-upload__tip">-->

<!--                  </div>-->
<!--                </el-upload>-->
<!--              </div>-->
<!--              <span>图片大小不能超过50MB</span>-->
<!--            </el-form-item>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
    <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer>
  </el-dialog>
</template>
<script>
import ImageViewer from '@/components/ImageViewer.vue'

export default {
  props: {
    showDlg: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  components: { ImageViewer },
  computed: {
    formatFileList() {
      return this.formData.fileList.map(file => {
        console.log('file: ', file)
        return {
          name: file.fileName,
          url: file.filePrefix + file.fileUrl
        }
      })
    },
    imageList() {
      return this.formatFileList.filter(item => {
        console.log('item', item)
        return item.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(
          item.name.substring(item.name.lastIndexOf('.')).toLowerCase()
        )
      })
    },
    imageArr() {
      return this.formatFileList.map(item => item.filePrefix + item.fileUrl)
    }
  },

  data() {
    return {
      formData: {
        contractNo: '', // 合同编号
        specId: '',
        lockedPrice: '',
        orderQuantity: '',
        // pickupDate: '',
        fileList: []
      },
      rules: {
        contractNo: [
          {
            required: true,
            message: '请输入合同编号',
            trigger: ['blur', 'change']
          }
        ],
        specId: [
          {
            required: true,
            message: '请选择粮油规格',
            trigger: ['blur', 'change']
          }
        ],
        lockedPrice: [
          {
            required: true,
            message: '请输入锁价单价(元)',
            trigger: ['blur', 'change']
          }
        ],
        orderQuantity: [
          {
            required: true,
            message: '请输入锁定数量',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      guigeList: [],
      dialogVisible: false,
      currentImageIndex: 0
    }
  },
  created() {
    this.getDetail()
    this.getGuige()
  },
  methods: {
    onPreview(file) {
      console.log('file', file)
      if (
        file.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(
          file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        )
      ) {
        this.currentImageIndex = this.imageList.findIndex(
          url => url.name === file.name
        )
        this.dialogVisible = true
      } else {
        window.open(file.url, '_blank')
      }
    },

    handleSuccess(res) {
      this.formData.fileList.push(res.data)
    },
    delImage(i) {
      this.formData.fileList.splice(i, 1)
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 50
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 50MB')
      }
      return isImage && isLt10M
    },
    getGuige() {
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.guigeList = res.list
        })
    },
    getDetail() {
      this.loading = true

      this.$axios
        .get(this.$apis.orderManage.selectYxPriceOrderByOrderId, {
          params: { orderId: this.orderId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          res.recordList = res.recordList ? res.recordList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleClose() {
      this.$emit('closeDlg')
    },
    changeSpec(val) {
      this.formData.lockedPrice = 0
      // if (val) {
      //   const info = this.guigeList.find(item => item.specId === val)
      //   if (info) {
      //     this.formData.lockedPrice = info.currentPrice || 0
      //   }
      // }
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.orderManage.selectYxPriceOrderByOrderId, {
          params: { orderId: this.orderId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          res.recordList = res.recordList ? res.recordList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitDlg() {
      this.$refs.form3
        .validate()
        .then(() => {
          this.loading = true

          const url = this.$apis.orderManage.updateYxPriceOrder

          this.$axios.post(url, this.formData).then(() => {
            this.$emit('saveSuccess')
            this.handleClose()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.images-wrap {
  display: flex;
  flex-wrap: wrap;

  .images-box {
    width: 148px;
    height: 148px;
    border: 1px dotted #ddd;
    border-radius: 10px;
    margin-right: 10px;
    position: relative;
    margin-bottom: 10px;

    .close-icon {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
      z-index: 10;
      font-size: 18px;
      color: red;
      cursor: pointer;
    }
  }
}

.uplaod-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
